module.exports = __webpack_public_path__ + "static/media/dots.8bd35f09.svg";